// src/utils/logout.js
export const handleLogout = () => {
  console.log("🚪 Logging out...");

  // 🔹 1. Clear session-only data
  sessionStorage.clear();

  // 🔹 2. Clear localStorage data
  localStorage.removeItem("firebaseToken");
  localStorage.removeItem("user");
  localStorage.removeItem("browser_heartbeat");

  // 🔹 3. Clear cookies across all subdomains of .s.com
  const domainParts = window.location.hostname.split(".");
  if (domainParts.length > 2) {
    // for subdomains like dashboard.s.com
    document.cookie = `firebaseToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${domainParts.slice(-2).join(".")}; SameSite=None; secure`;
    document.cookie = `user=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${domainParts.slice(-2).join(".")}; SameSite=None; secure`;
  } else {
    // fallback for localhost or base domain
    document.cookie = `firebaseToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=None; secure`;
    document.cookie = `user=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=None; secure`;
  }

  // 🔹 4. Broadcast logout to all open tabs (cross-tab sync)
  localStorage.setItem("cross_tab_logout", Date.now().toString());

  // 🔹 5. Redirect to centralized login
  const redirectURL = encodeURIComponent(window.location.origin);
  const authURL = `https://auth.yesedacademy.com?redirect=${redirectURL}`;
  window.location.href = authURL;
};
